import { render, staticRenderFns } from "./FormElementImageButton.vue?vue&type=template&id=8d7c6268&scoped=true&"
import script from "./FormElementImageButton.vue?vue&type=script&lang=js&"
export * from "./FormElementImageButton.vue?vue&type=script&lang=js&"
import style0 from "./FormElementImageButton.vue?vue&type=style&index=0&id=8d7c6268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7c6268",
  null
  
)

export default component.exports